import createActions from 'utils/redux/createActions'

export default createActions([
	'NEW_PROJECT_CHANGED'
])



// WEBPACK FOOTER //
// ./src/actions/newProjectActions.js